import {
  COURSE_STEPS,
  DAILY_CHALLENGE_STEPS,
  STUDENT_STEPS,
} from './RemoveWithStepsModal.config';

export const getStepsByVariant = (variant: any) => {
  switch (variant) {
    case 'COURSE': {
      return COURSE_STEPS.map((step: any) => ({
        ...step,
        loading: false,
        error: false,
        completed: false,
      }));
    }
    case 'DAILY_CHALLENGE': {
      return DAILY_CHALLENGE_STEPS.map((step: any) => ({
        ...step,
        loading: false,
        error: false,
        completed: false,
      }));
    }
    case 'STUDENT': {
      return STUDENT_STEPS.map((step: any) => ({
        ...step,
        loading: false,
        error: false,
        completed: false,
      }));
    }
  }
};

export const getStepsProgress = (steps: any) => {
  const completedSteps = steps.filter((step: any) => step.completed);

  return (completedSteps.length * 100) / steps.length;
};
